import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'business-medium-large',
  footer: 'business-medium-large',
}

const pageBrand: PageBrand = 'corporate'

export const mediumLargeBusiness = new LineOfBusinessConfig(geConfig, pageBrand)
